import {ThreeDotsLoader} from '@chekinapp/ui';

export const ViewLoader = () => {
  return (
    <div
      data-app-loader=""
      className="flex h-[var(--app-vh,100vh)] flex-col items-center justify-center"
    >
      <ThreeDotsLoader color="var(--primary)" width={60} height={60} />
    </div>
  );
};
